import * as React from 'react'
import HeaderMenuComponent from './headerMenuComponent'
import { Link } from 'react-scroll'

interface Props {
	title: string
	description: string
	isTopPage: boolean
}

export default class HeaderComponent extends React.Component<Props> {
	constructor(props: Props) {
		super(props)
	}

	render() {
		return (
			<div>
				<HeaderMenuComponent isTopPage={this.props.isTopPage} />
				<div className="main-visual">
					<div className="row">
						<div className="container-fluid">
							<h1>{this.props.title}</h1>
							<h2>{this.props.description}</h2>
							<a className="scroll-down">SCROLL</a>
							<div id="scrollDown" className="scroll-down">
								<Link
									to="service"
									smooth={true}
									duration={640}
								>
									<img src="img/btn_scroll_down.png"/>
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/common/headerComponent.tsx